import { render } from "./ContentEn.vue?vue&type=template&id=0d2d876a"
import script from "./ContentEn.vue?vue&type=script&lang=js"
export * from "./ContentEn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__